import ApiConstants from "../constants/ApiConstants";
import Utility from "../utility/Utility";
import http from "../http";
import moment from 'moment';


export interface  StatutoryReportAPIConfig {
    from: string;
    to: string;
    form?: string;
    employeeId?: number[]
    filterOptions?:{
        currentPage : number
        limit : number
    }

}

const defaultConfig: StatutoryReportAPIConfig = {
    from : moment(moment().format()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
    to : moment(moment().format()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
    form:"PT",
    employeeId: [],
    filterOptions: {
        currentPage:1,
        limit:20
    }
};

class StatutoryReportFieldService {

    static apiConfig: StatutoryReportAPIConfig;
    static defaultConfig =  defaultConfig;
    static getProfessionalTaxReport() {

        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }

        

        const url = ApiConstants.URL.PAYROLL.PAYSTUB + "/statutory-report";
        return http.post(url, this.apiConfig).catch(
            (error) => {
                console.error('Error while fetching statutory report : ', error);
                return Promise.reject(error);
            }
        );
    }
}

export default StatutoryReportFieldService